/**
 * resusable component to create and edit resource links
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Modal from '../../../global/components/modals/Modal.js.jsx';

import {
  TextInput
  , TextAreaInput
} from '../../../global/components/forms';

class StudyCustomEmailModal extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    const { 
      closeAction
      , confirmAction
      , customEmailBody
      , customEmailSubject
      , isOpen
      , onChange
    } = this.props;

    return (
      <Modal
        cardSize='standard'
        closeAction={closeAction}
        closeText="Cancel"
        confirmAction={confirmAction}
        confirmText="Send email"
        disableConfirm={!customEmailBody || !customEmailSubject}
        isOpen={isOpen}
        modalHeader={`Custom Email Alert Modal`}
        showButtons={true}
      >
        <div>
          <h3>Send A Custom Email Alert</h3>
          <p>This will send the following message to all active members of this Program. Please be careful and make sure everything is correct before you hit send.</p>
          <div className="yt-col full s_60">
            <TextInput
              change={onChange}
              label="Subject Line"
              name="customEmailSubject"
              required={true}
              value={customEmailSubject}
            />
            <TextAreaInput
              change={onChange}
              label="Message Body"
              name="customEmailBody"
              required={true}
              value={customEmailBody}
            />
          </div>
        </div>
      </Modal>
    )
  }
}

StudyCustomEmailModal.propTypes = {
  closeAction: PropTypes.func.isRequired
  , confirmAction: PropTypes.func.isRequired
  , isOpen: PropTypes.bool.isRequired
  , onChange: PropTypes.func.isRequired
  , customEmailBody: PropTypes.string
  , customEmailSubject: PropTypes.string
}

StudyCustomEmailModal.defaultProps = {
  isOpen: false
}


export default StudyCustomEmailModal;



// WEBPACK FOOTER //
// modules/study/components/StudyCustomEmailModal.js.jsx